import React, { Component, Fragment } from 'react';
//import "./details-popup.less";
import Overlay from 'Components/Overlay';
import Moment from "moment";
import SubHeading from 'Components/SubHeading';
import Dropdown from 'Components/Dropdown';
import Input from "Components/Input";
import { DateRangePicker } from 'react-dates';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import classNames from 'classnames';
import { getUser } from 'Utils/storage';
import { ABFRL } from 'Constants/commonConstants';

class EditPopup extends Component {
    constructor(props) {
       super(props);
       this.state = {
        editData: this.props.selectedContract,
        isEnabled: true
       }
    }

    setFromLocation = (location)=> {
        let { editData } = this.state;
        (editData.stops || [])[0].location = location.location;
        (editData.stops || [])[0].city = location.city;
        (editData.stops || [])[0].state = location.state;
        (editData.stops || [])[0].country = location.country;
        this.setState({editData})
    }

    setToLocation = (location)=> {
        let { editData } = this.state;
        const destinationIndex = (editData.stops || []).length - 1;
        (editData.stops || [])[destinationIndex].location = location.location;
        (editData.stops || [])[destinationIndex].city = location.city;
        (editData.stops || [])[destinationIndex].state = location.state;
        (editData.stops || [])[destinationIndex].country = location.country;
        this.setState({editData})
    }

    updateContract = (data) => {
        const destinationIndex = (data.stops || []).length - 1;
        if(!(data.contract_type && (data.stops || [])[0].city && (data.stops || [])[0].state && (data.stops || [])[destinationIndex].city && (data.stops || [])[destinationIndex].state && data.vehicle_type && data.vehicle_body_type && data.pricing_basis_id && data.contract_trip_id && data.price && data.transporter_id && data.trip_contract_tenure_from && data.trip_contract_tenure_to)){
            console.log('inside if',this.state.isEnabled)
            this.setState({isEnabled: false})
        } else {
            console.log('inside else',this.state.isEnabled)
            this.setState({isEnabled: true}, () =>
                this.props.updateContract(data)
            );
        }
    }

    render(){
    const { 
        selectedContract,
         transporters, 
         vehicleTypes, 
         vehicleBodyTypes, 
         pricingBasis, 
         multiContractTypes, 
         multiTripTypes, 
         contract_status , 
         serviceModeTypesList} = this.props;
    let { editData } = this.state;

    const destinationIndex = (editData.stops || []).length - 1;
    const user = getUser();

    return(
        <div className="multicontract-popup">
        <Overlay>
        
            <div className="bg-white box-shadow ph-20 pv-20 br-100 pr-40">
                <div className="mb-20 tleft header-medium-color border-bottom-light-2 pb-10 fSemibold fs-18">Contract Details
                <span className="pr-10 fRight curP" id='close' onClick={this.props.closeEdit}>x</span> 
                </div>
                {contract_status !== 3 ?
                (<div className="flex flex-wrap mb-50 pr-10 mt-30 d-block text-center">

                    <div className='wt-100p flex'>
                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                        <div className="mb-10 text-center fs-16 fBold">Contract Type<span className='error-color'>*</span></div>
                            <Dropdown
                                items={multiContractTypes}
                                selectedItem={multiContractTypes.find(vType => {return editData.contract_type_name === vType.name})}
                                displayKey="name"
                                name="multiContractTypes"
                                label="Select Contract Type"
                                searchEnabled={true}
                                searchPlaceholder={'Search Contract Type'}
                                onSelect={(value) => {
                                    editData.contract_type_name = value.name;
                                    editData.contract_type = value.id;
                                    this.setState({editData})
                                }
                                }
                                className="text-center wt-250 fs-14"
                                canClear={true}
                            />
                        </div>
                        <div className="col-3 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                            <div className="mb-10 text-center fs-16 fBold">From<span className='error-color'>*</span></div>
                            <div className='flex'>
                                <PlacesAutoComplete setLocation={this.setFromLocation.bind(this)} value={(editData.stops || [])[0].city || ''}/>
                                <Input value={(editData.stops || [])[0].state || ''} readOnly={true}/>
                            </div>
                        </div>
                        <div className="col-3 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                            <div className="mb-10 text-center fs-16 fBold">To<span className='error-color'>*</span></div>
                            <div className='flex'>
                                <PlacesAutoComplete setLocation={this.setToLocation.bind(this)} value={(editData.stops || [])[destinationIndex].city || ''}/>
                                <Input value={(editData.stops || [])[destinationIndex].state || ''} readOnly={true}/>
                            </div>
                        </div>
                    </div>
                    <div className='wt-100p flex mt-20'>
                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                        <div className="mb-10 text-center fs-16 fBold">Vehicle Type<span className='error-color'>*</span></div>
                        <Dropdown
                            items={vehicleTypes}
                            selectedItem={vehicleTypes.find(vType => {return (editData.vehicle_details || {}).vehicle_type_name === vType.name})}
                            displayKey="name"
                            name="vehicleType"
                            label="Select Vehicle Type"
                            searchEnabled={true}
                            searchPlaceholder={'Search Vehicle Type'}
                            onSelect={(value) => {
                                (editData.vehicle_details || {}).vehicle_type_name = value.name;
                                (editData.vehicle_details || {}).vehicle_type = value.value;
                                this.setState({editData})
                            }
                            }
                            className="text-center wt-250 fs-14"
                            canClear={true}
                        />
                    </div>

                    <div className="col-3 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                        <div className="mb-10 text-center fs-16 fBold">Vehicle Body Type<span className='error-color'>*</span></div>
                        <Dropdown
                            items={vehicleBodyTypes}
                            selectedItem={vehicleBodyTypes.find(vType => {return (editData.vehicle_details || {}).vehicle_body_type_name === vType.name})}
                            displayKey="name"
                            name="vehicleBodyTypes"
                            label="Select Vehicle Body Type"
                            searchEnabled={true}
                            searchPlaceholder={'Search Vehicle Body Type'}
                            onSelect={(value) => {
                                (editData.vehicle_details || {}).vehicle_body_type_name = value.name;
                                (editData.vehicle_details || {}).vehicle_body_type = value.value;
                                this.setState({editData})
                            }
                            }
                            className="text-center wt-250 fs-14"
                            canClear={true}
                        />
                    </div>

                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                        <div className="mb-10 text-center fs-16 fBold">Pricing Basis<span className='error-color'>*</span></div>
                        <Dropdown
                            items={pricingBasis}
                            selectedItem={pricingBasis.find(type => editData.pricing_basis_id === type.value)}
                            displayKey="name"
                            name="pricingBasis"
                            label="Select Pricing Basis"
                            searchEnabled={true}
                            searchPlaceholder={'Search Pricing Basis'}
                            onSelect={(value) => {
                                editData.pricing_basis_name = value.name;
                                editData.pricing_basis_id = value.value;
                                this.setState({editData})
                            }
                            }
                            className="text-center wt-250 fs-14"
                            canClear={true}
                        />
                    </div>
                    
                    </div>

                    <div className='wt-100p flex mt-20'>
                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                    <div className="mb-10 text-center fs-16 fBold">Minimum KM</div>
                        <Input
                            value={editData.minimum_km}
                            onChange={(e) => {
                                editData.minimum_km = e.target.value ? Number(e.target.value) : e.target.value;
                                this.setState({editData})
                                }
                            }
                            placeholder="Min. KM"
                            className={'inBlock wt-250 pr-15'}
                            readOnly={false}
                        />
                    </div>

                    <div className="col-3 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                    <div className="mb-10 text-center fs-16 fBold">Per KM If Exceed</div>
                        <Input
                            value={editData.exceed_per_km}
                            onChange={(e) => {
                                editData.exceed_per_km = e.target.value ? Number(e.target.value) : e.target.value;
                                this.setState({editData})
                                }
                            }
                            placeholder="Per KM If Exceed"
                            className={'inBlock wt-250 pr-15'}
                            readOnly={false}
                        />
                    </div>

                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                        <div className="mb-10 text-center fs-16 fBold">Trip Type<span className='error-color'>*</span></div>
                        <Dropdown
                            items={multiTripTypes}
                            selectedItem={multiTripTypes.find(trip => {return editData.contract_trip_name === trip.name})}
                            displayKey="name"
                            name="multiTripTypes"
                            label="Select Trip Type"
                            searchEnabled={true}
                            searchPlaceholder={'Search Trip Type'}
                            onSelect={(value) => {
                                editData.contract_trip_name = value.name;
                                editData.contract_trip_type = value.id;
                                this.setState({editData})
                            }
                            }
                            className="text-center wt-250 fs-14"
                            canClear={true}
                        />
                    </div>
                    </div>

                    <div className='wt-100p flex mt-20'>

                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                    <div className="mb-10 text-center fs-16 fBold">Total Trip KM</div>
                        <Input
                            value={editData.totalKm}
                            onChange={(e) => {
                                editData.totalKm = e.target.value;
                                this.setState({editData})
                                }
                            }
                            placeholder="Total Trip KM"
                            className={'inBlock wt-250 pr-15'}
                            readOnly={false}
                        />
                    </div>
                    <div className="col-3 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                    <div className="mb-10 text-center fs-16 fBold">Route Name/Code</div>
                        <Input
                            value={editData.route_code}
                            onChange={(e) => {
                                editData.route_code = e.target.value;
                                this.setState({editData})
                                }
                            }
                            placeholder="Route Name/Code"
                            className={'inBlock wt-250 pr-15'}
                            readOnly={false}
                        />
                    </div>
                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                    <div className="mb-10 text-center fs-16 fBold">Rate<span className='error-color'>*</span></div>
                        <Input
                            value={editData.price}
                            onChange={(e) => {
                                editData.price = e.target.value ? Number(e.target.value) : e.target.value;
                                this.setState({editData})
                                }
                            }
                            placeholder="Total Trip KM"
                            className={'inBlock wt-250 pr-15'}
                            readOnly={false}
                        />
                    </div>
                    </div>
                    <div className='wt-100p flex mt-20'>

                        <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                            <div className="mb-10 text-center fs-16 fBold">Transporter<span className='error-color'>*</span></div>
                            <Dropdown
                                items={transporters}
                                selectedItem={transporters.find(transporter => {return editData.transporter_name === transporter.name})}
                                displayKey="name"
                                name="transporter"
                                label="Select Transporter"
                                searchEnabled={true}
                                searchPlaceholder={'Search Transporter'}
                                onSelect={(value) => {
                                    editData.transporter_name = value.name;
                                    editData.transporter_id = value.id;
                                    this.setState({editData})
                                }
                                }
                                className="text-center wt-250 fs-14"
                                canClear={true}
                            />
                        </div>
                        <div className="mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                            <div className="fBold fs-16 mb-5 header-medium-color mb-10">
                            Contract Tenure<span className='error-color'>*</span>
                            </div>
                        <div className="mb-10" >
                            <DateRangePicker
                                startDate={!editData.trip_contract_tenure_to ? Moment(editData.trip_contract_tenure_from || null) : Moment(editData.trip_contract_tenure_from)}
                                startDateId="startDate"
                                endDate={editData.trip_contract_tenure_to ? Moment(editData.trip_contract_tenure_to) : null}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => {
                                const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                                const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                editData.trip_contract_tenure_from = startDateTime;
                                editData.trip_contract_tenure_to = endTime;
                                this.setState({editData});
                                }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={() => false}
                            />
                            </div>

                        </div>
                        {ABFRL.includes(user.companyId)&&
                        <div className="wt-250 mt-5 ml-63 mb-2 mr-20 w-inherit text-center">
                            <div className="mb-10 text-center fs-16 fBold">Mode Type</div>
                            <Dropdown
                                items={serviceModeTypesList}
                                selectedItem={serviceModeTypesList.find(serviceMode => {return editData.service_mode_name === serviceMode.name})}
                                displayKey="name"
                                name="Service Mode"
                                label="Select Service Mode"
                                searchEnabled={true}
                                searchPlaceholder={'Search Mode'}
                                onSelect={(value) => {
                                    editData.service_mode_name = value.name;
                                    editData.service_mode_id = value.value;
                                    this.setState({editData})
                                }
                                }
                                className="inBlock wt-250 pr-15"
                                canClear={true}
                            />
                        </div>}
                    </div>

                    {ABFRL.includes(user.companyId)&&
                    <div className='wt-100p flex mt-20'>
                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                            <div className="mb-10 text-center fs-16 fBold">Route City</div>
                                <Input
                                value={editData.route_city}
                                onChange={(e) => {
                                    editData.route_city = e.target.value;
                                    this.setState({editData})
                                    }
                                }
                                placeholder="Route City"
                                className={'inBlock wt-250 pr-15'}
                                readOnly={false}
                                />
                    </div>

                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                            <div className="mb-10 text-center fs-16 fBold">Leg Sequence</div>
                                <Input
                                value={editData.leg_sequence}
                                onChange={(e) => {
                                    editData.leg_sequence = e.target.value;
                                    this.setState({editData})
                                    }
                                }
                                placeholder="Leg Sequence"
                                className={'inBlock wt-250 pr-15'}
                                readOnly={false}
                                />
                    </div>
                            
                    

                    </div>}

                     
                    <div className='mt-20 flex fRight'>
                        <button className={classNames("br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10 mt-30", {
                        		'disabled curNA' : !(editData.contract_type && (editData.stops || [])[0].city && (editData.stops || [])[0].state && (editData.stops || [])[destinationIndex].city && (editData.stops || [])[destinationIndex].state && (editData.vehicle_details || {}).vehicle_type && (editData.vehicle_details || {}).vehicle_body_type && editData.pricing_basis_id)})}//  && editData.contract_trip_id && editData.price && editData.transporter_id && editData.trip_contract_tenure_from && editData.trip_contract_tenure_to)})}
                                onClick={() => this.props.updateContract(editData)}>Save</button>
                        <button className="br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10 mt-30" onClick={this.props.closeEdit}>Cancel</button>
                    </div> 
                </div>)
                :
                (<div className="flex flex-wrap mb-50 pr-10 mt-30 d-block text-center">
                    <div className='wt-100p flex mt-20'>
                    <div className="mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                        <div className="fBold fs-16 mb-5 header-medium-color mb-10">
                        Contract Tenure<span className='error-color'>*</span>
                        </div>
                        <div className="mb-10" >
                            <DateRangePicker
                                startDate={!editData.trip_contract_tenure_to ? Moment(editData.trip_contract_tenure_from || null) : Moment(editData.trip_contract_tenure_from)}
                                startDateId="startDate"
                                endDate={editData.trip_contract_tenure_to ? Moment(editData.trip_contract_tenure_to) : null}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => {
                                const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                                const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                editData.trip_contract_tenure_from = startDateTime;
                                editData.trip_contract_tenure_to = endTime;
                                this.setState({editData});
                                }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={() => false}
                            />
                            </div>

                            </div>
                        </div> 
                        <div className='mt-20 flex fRight'>
                            <button className={classNames("br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10 mt-30", {
                                    'disabled curNA' : !(editData.contract_type && (editData.stops || [])[0].city && (editData.stops || [])[0].state && (editData.stops || [])[destinationIndex].city && (editData.stops || [])[destinationIndex].state && (editData.vehicle_details || {}).vehicle_type && (editData.vehicle_details || {}).vehicle_body_type && editData.pricing_basis_id)})}//  && editData.contract_trip_id && editData.price && editData.transporter_id && editData.trip_contract_tenure_from && editData.trip_contract_tenure_to)})}
                                    onClick={() => this.props.updateContract(editData)}>Save</button>
                            <button className="br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10 mt-30" onClick={this.props.closeEdit}>Cancel</button>
                        </div>
                    </div>
                    )
                }
            </div>
        </Overlay> 
    </div>
    )}
}

export default EditPopup;